import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import ReactGA from 'react-ga';
import '../App.css';
import MessagesComponent from './MessagesComponent';
import data from '../data';

class ChatComponent extends Component{
    constructor(props){
        super(props);
        this.state ={
            data: this.props.data,
            messages: [],
            whoButton: false,
            technologiesButton: false,
            projectButton: false,
            contactButton: false,
            typing: true,
            responding: false,
            active: false
        }
    }
    componentDidMount(){
        // this.props.activateChat(true);
        this.loadHandler()
    }
    loadHandler = () =>{
        ReactGA.event({
            category: 'User',
            action: 'Load Handler'
          });
        this.setState({responding: true, active: true});
        
        setTimeout(() =>{
            var res = this.state.messages.concat({
                "user": "time",
                "message": new Date().toLocaleString()
            }).concat({
                "user": "me",
                "message": "Hello there, I'm Matthew Ishii!"
            });
        this.setState({messages: res, responding: false});
        }, 2500);
        
    }
    whoHandler = () =>{
        ReactGA.event({
            category: 'User',
            action: 'WhoHandler'
          });
        this.setState({whoButton: true, responding: true});
        var res = this.state.messages.concat(
            {
                "user": "guest",
                "message": "Who are you?",
            }
        );
        this.setState({messages:res});
        setTimeout(() =>{
            this.setState({typing: false});
        }, 500);
        
        setTimeout(() =>{
            this.setState({typing: true});
            var res = this.state.messages.concat(
                {
                    "user": "me",
                    "message": data.DetailedAboutMe
                }
            )
            this.setState({messages: res, responding: false});
        }, 4000)
    
    }
    technologiesHandler = () =>{
        ReactGA.event({
            category: 'User',
            action: 'Technologies Handler'
          });
        this.setState({technologiesButton: true, responding: true})
        var res = this.state.messages.concat(
            {
            "user": "guest",
            "message": "What technologies do you know?"
            }
        );
        this.setState({messages: res, typing: true});
        setTimeout(() =>{
            this.setState({typing: false});
        }, 500);
        setTimeout(() =>{
            var res = this.state.messages.concat(
                {
                    "user": "me",
                    "message": `I'm quite knowledgeable with ${([...data.Technologies.Languages]).join(", ")}`
                }
            )
            this.setState({messages: res, typing: true});
        }, 2000);
        setTimeout(() =>{
            this.setState({typing: false});
        }, 2500);
        setTimeout(() =>{
            var res = this.state.messages.concat(
                {
                    "user": "me",
                    "message": `I've utilized ${([...data.Technologies.Database]).join(", ")} to store my data.`
                }
            )
            this.setState({messages: res, typing: true});
        }, 3500);
        setTimeout(() =>{
            this.setState({typing: false});
        }, 4000);
        setTimeout(() =>{
            var res = this.state.messages.concat(
                {
                    "user": "me",
                    "message": `And love playing with ${([...data.Technologies.Frameworks]).join(", ")} to build my web applications!`
                }
            )
            this.setState({messages: res, typing: true, responding: false});
        }, 5500);
    }
    projectHandler = () =>{
        ReactGA.event({
            category: 'User',
            action: 'Project Handler'
          });
        this.setState({projectButton: true, responding: true});
        var res = this.state.messages.concat({
            "user": "guest",
            "message": "Do you have any projects?"
        });
        this.setState({messages: res});

        setTimeout(()=>{
            this.setState({typing: false});
        }, 500);
        
        setTimeout(() =>{
            var res = this.state.messages.concat({
                "user": "me",
                "message": `Yes! I have many projects. Feel free to check out my <a href=${data.ProjectLink} target="_blank">live projects</a> or <a href=${data.GitHubLink} target="_blank">code on github</a>!`,
                "link": [
                    data.ProjectLink,
                    data.socialLinks[1].url,
                ]
            })
            this.setState({messages: res, typing: true, responding: false});
        }, 2500)
    }
    contactHandler = () =>{
        ReactGA.event({
            category: 'User',
            action: 'Contact Handler'
          });
        this.setState({contactButton: true, responding: true});
        var res = this.state.messages.concat({
            "user":"guest",
            "message": "How can I contact you?"
        });
        this.setState({messages: res});
        setTimeout(()=>{
            this.setState({typing: false});
        }, 500);
        setTimeout(()=>{
            var res = this.state.messages.concat({
                "user": "me",
                "message": `The best way to get in contact with me is through <a href=${data.socialLinks[0].url} target="_blank">LinkedIn</a>!`
            })
            this.setState({messages: res, typing: true, responding: false});
        }, 2000);
    }
    render(){
        return(
            <div>

                 <MessagesComponent messages={this.state.messages}></MessagesComponent>
                

                <div className="typingDisplay" hidden={this.state.typing}>
                    <span>.</span><span>.</span><span>.</span>
                </div>
                <div className="chatMenu border-top">
                    <div className="btn-row col-sm-8 text-center"> 
                        <div hidden={this.state.responding}>
                        <Button className="chatButton" variant="primary" size="sm" onClick={this.whoHandler} hidden={this.state.whoButton}>Who are you?</Button>
                        <Button className="chatButton" variant="primary" size="sm" onClick={this.technologiesHandler} hidden={this.state.technologiesButton}>What technologies do you know?</Button>
                        <Button className="chatButton" variant="primary" size="sm" onClick={this.projectHandler} hidden={this.state.projectButton}>Do you have any projects?</Button>
                        <Button className="chatButton" variant="primary" size="sm" onClick={this.contactHandler} hidden={this.state.contactButton}>How can I contact you?</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChatComponent;